// import the react components
import React, {useEffect, useState} from "react";
import dayjs from "dayjs";

// import the icons
import {Calendar, PersonStanding, Flame, Sunrise} from "lucide-react";

// import the custome components
import DayModal from "./../ui/schedule/day-modal";
import EventModal from "./../ui/schedule/event-modal";
import PatientModal from "./../ui/patient/patient-modal";
import Title from "./../ui/title";
import DashboardCard from "./../ui/schedule/dashboard-card";
import CalendarHeader from "./../ui/schedule/calendar-header";
import Month from "./../ui/schedule/month";

// import the utulities
import {get_month} from "./../assets/data/utilities";
import {useStateContext} from "./../context/";
import useNavigation from "./../context/navigation";
import axios from "axios";
import {CALENDAR_API} from "./../assets/data/api";

// the schedule funtional based component
const Schedule = () => {
    const {month_index, show_event_modal, show_day_modal, patient_modal, is_loged, dispatch_event, set_is_loading, saved_events} = useStateContext();
    const [current_month, set_current_month] = useState(get_month());
    const [statistic, set_statistic] = useState({patients: 0, events: 0, tomorrow: 0});
    useNavigation();

    // check if the month changed
    useEffect(() => {
        set_current_month(get_month(month_index));
    }, [month_index]);

    // get the current user events
    useEffect(() => {
        saved_events.length === 0 && set_is_loading(false);

        // prepare the query
        const endpoint = CALENDAR_API + "read.php";
        const data = {username: is_loged.username};
        axios.post(endpoint, data).then(response => {
            const {data} = response;
            if (data.success) dispatch_event({type: "add", payload: data.events});
            set_is_loading(false);
        });
    }, []);

    // get the statistic
    const card_statistic = () => {

        // the statistic data
        let patients = [];
        let events = [];
        let tomorrow = [];

        // filter the events
        const format = "DD-MM-YY";
        saved_events.filter(event => {
            if (dayjs(event.day).format(format) === dayjs().format(format)){

                // separate the data
                if (event.type === "appointment") patients.push(event);
                else if (event.type === "event") events.push(event);
            }

            else if (dayjs(event.day).format(format) === dayjs().add(1, "day").format(format)){
                if (event.type === "appointment") tomorrow.push(event);
            }
        });

        // update the statistic
        set_statistic({patients: patients.length, events: events.length, tomorrow: tomorrow.length});
    };
    useEffect(card_statistic, [saved_events]);

    // the dashboard cards
    const card_data = [
        {
            label: "Today patients",
            value: `${statistic.patients} patients`,
            icon: <PersonStanding />,
        },
        {
            label: "Today events",
            value: `${statistic.events} events`,
            icon: <Flame />,
        },
        {
            label: "Tomorrow patients",
            value: `${statistic.tomorrow} patients`,
            icon: <Sunrise />,
        },
    ];

    // return to the component data
    return (
        <div>
            {show_day_modal && <DayModal />}
            {show_event_modal && <EventModal />}
            {patient_modal && <PatientModal />}

            <Title text="schedule" icon={<Calendar size={22} />} />

            <div className="flex flex-wrap justify-center lg:flex-nowrap gap-3">
                {card_data.map(item => (
                    <DashboardCard key={item.label} label={item.label} value={item.value} sub={item.sub} icon={item.icon} />
                ))}
            </div>

            <div className="flex flex-col mt-4 mb-6 sm:mt-8 sm:mb-10 min-h-screen sm:h-auto" style={{height: "1000px"}}>
                <CalendarHeader />
                <Month month={current_month} />
            </div>
        </div>
    );
};
export default Schedule;